import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatRippleModule } from '@angular/material/core';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { RouterModule } from '@angular/router';

import { MgButtonModule } from '@app/src/app/button';
import { MgEmptyStateModule } from '@app/src/app/components/EmptyState';
import { MgImageModule } from '@app/src/app/components/MgImage';
import { MgIconModule } from '@app/src/app/icon';
import { PermissionsModule } from '@app/src/app/permissions';
import { MgPipesModule } from '@app/src/app/pipes';
import { FormRelativeTimeInputModule } from '@app/src/app/shared/components/form-relative-time-input/form-relative-time-input.module';
import { MobileCardModule } from '@app/src/app/shared/components/tables/mobile-card/mobile-card.module';
import { DayjsPipesModule } from '@app/src/app/shared/pipes/dayjs/dayjs-pipes.module';
import { MgSpinnerModule } from '@app/src/app/spinner';

import { FormModule } from '@shared/components/form';
import { GenericModule } from '@shared/components/generic';
import { ManagerOverlayModule } from '@shared/components/manager-overlay';
import { OverlayModule } from '@shared/components/modal-overlay';
import { TextModule } from '@shared/components/text/text.module';
import { TooltipModule } from '@shared/components/tooltip';
import { SortHeaderModule } from '@shared/directives/sort-header/sort-header.module';
import {
  FlexTimeActivityInstanceService,
  FlexTimeActivityService,
  FlexTimePeriodService,
} from '@shared/services/flex-time';

import { FtmSharedModule } from '../ftm-shared/ftm-shared.module';
import { FtmPeriodsActivityEditComponent } from './components/ftm-periods-activity-edit/ftm-periods-activity-edit.component';
import { FtmPeriodsEditComponent } from './components/ftm-periods-edit/ftm-periods-edit.component';
import { FtmPeriodsComponent } from './ftm-periods.component';
import { CountActivityInstancesPipe, TotalRegisteredPipe } from './pipes';
import { FtmPeriodsService } from './services';

@NgModule({
  imports: [
    // Minga dependencies
    ManagerOverlayModule,
    MgSpinnerModule,
    MgButtonModule,
    FormModule,
    MgIconModule,
    MgEmptyStateModule,
    OverlayModule,
    MgPipesModule,
    TooltipModule,
    MgImageModule,
    FtmSharedModule,
    TextModule,
    GenericModule,
    FormRelativeTimeInputModule,
    SortHeaderModule,
    MobileCardModule,
    DayjsPipesModule,
    PermissionsModule,

    // External dependencies
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    MatFormFieldModule,
    MatTableModule,
    MatSortModule,
    MatRippleModule,
    ReactiveFormsModule,
    MatStepperModule,
    RouterModule,
    MatTooltipModule,
  ],
  declarations: [
    // Pipes
    CountActivityInstancesPipe,
    TotalRegisteredPipe,

    // Components
    FtmPeriodsComponent,
    FtmPeriodsEditComponent,
    FtmPeriodsActivityEditComponent,
  ],
  exports: [FtmPeriodsComponent],
  providers: [FlexTimePeriodService, FlexTimeActivityService, FtmPeriodsService, FlexTimeActivityInstanceService],
})
export class FtmPeriodsModule {}
